import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectFormRoute: InvariantJiraRoute = {
	name: 'classic-business-form',
	path: '/jira/core/projects/:projectKey/form',
	exact: true,
};
